module.exports = __webpack_public_path__ + "img/img03.c9dae272.png";